/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Brief_DescInputs */

const en_mk_tb_brief_desc = /** @type {(inputs: Mk_Tb_Brief_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agree on the audience and first outcome; keep open questions visible.`)
};

const id_mk_tb_brief_desc = /** @type {(inputs: Mk_Tb_Brief_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sepakati pengguna dan hasil pertama; catat pertanyaan yang belum terjawab.`)
};

/**
* | output |
* | --- |
* | "Agree on the audience and first outcome; keep open questions visible." |
*
* @param {Mk_Tb_Brief_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_brief_desc = /** @type {((inputs?: Mk_Tb_Brief_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Brief_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_brief_desc(inputs)
	return en_mk_tb_brief_desc(inputs)
});